import BaseApi from "../../../utils/BaseApi";


export async function replaceContentOptimized(content) {
    let processedContent = content;
    let contacts = content.matchAll(
        /#\d+#/g,
    )
    let contactDict = {};
    for (let contact of contacts){
        const url = `contact/${contact[0].replaceAll('#', '')}/`;
        const params = {};
        const api = new BaseApi();
        let response = await api.get(url, params)
        contactDict[response.data.id?.toString()] = `${response.data.last_name?response.data.last_name:''} ${response.data.first_name?response.data.first_name:''} ${response.data.patronymic?response.data.patronymic:''}`
    }
    processedContent = processedContent.replaceAll(
        /#\d+#/g,
        (match) => {
            return `<span class="commentDogBubble">
                        <a href="/contact/detail/${match.replaceAll('#', '')}/" target="_blank">
                            ${contactDict[match.replaceAll('#', '')]}
                        </a>
                    </span>`
        }
    )
    processedContent = processedContent.replace(
        /(@([A-Za-z]+(\.?)[A-Za-z0-9]+))/g,
        (match) => `<span class="commentDogBubble">${match}</span>`
    );
    processedContent = processedContent.replace(
        /\{\{[\S.]+\}\}/g,
        ''
    );

    return processedContent;
}

